import * as theme from "../theme";

import { useContext, useEffect } from "react";

import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Spinner from "../components/Spinner";
import Context from "../contexts/data";
import { getLenderByBuyer } from "../util/lenders";

const Result = () => {
  const { isFetchResult, matchedLender, submitProblem, firstName, lastName, handleUpdateFormValue } = useContext(Context);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!window.location.href.includes("localhost")) return;
    const mockBuyer = searchParams.get("mock_buyer");
    if (mockBuyer) {
      const lender = getLenderByBuyer(mockBuyer);
      if (lender) handleUpdateFormValue("matchedLender", lender);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fullName =
    firstName && lastName ? `${firstName} ${lastName}` : "RateZip User";

  let lenderMatchContent = (
    <SmallerTextContainer>
      <SmallerText>
        Your information has been forwarded to a participating lender.
      </SmallerText>
    </SmallerTextContainer>
  );

  if (matchedLender) {
    const { logoPosition = "below", align = "center" } = matchedLender.layout || {};

    const logoBlock = matchedLender.logoSrc && (
      <LogoContainer $align={align}>
        {matchedLender.url ? (
          <a href={matchedLender.url} target="_blank" rel="noreferrer">
            <LenderLogo src={matchedLender.logoSrc} alt={matchedLender.displayName} />
          </a>
        ) : (
          <LenderLogo src={matchedLender.logoSrc} alt={matchedLender.displayName} />
        )}
        {matchedLender.nmls && <p>{matchedLender.nmls}</p>}
      </LogoContainer>
    );

    const textBlock = (
      <SmallerTextContainer>
        <SmallerText $align={align}>{matchedLender.adCopy}</SmallerText>
      </SmallerTextContainer>
    );

    lenderMatchContent = (
      <>
        {logoPosition === "above" ? logoBlock : null}
        {textBlock}
        {logoPosition !== "above" ? logoBlock : null}
      </>
    );
  }

  if (isFetchResult) {
    return (
      <Wrapper>
        <HeadBiggerTextContainer>
          <HeadBiggerText>Thank you {fullName}.</HeadBiggerText>
        </HeadBiggerTextContainer>
        <Spinner text="Loading your offers..." />
      </Wrapper>
    );
  }

  // Regulatory requirement (VA mortgage exam, 2026-08): the consumer must be
  // notified when their submission could not be matched or delivered.
  if (submitProblem) {
    return (
      <Wrapper>
        <HeadWrapper>
          <HeadBiggerTextContainer>
            <HeadBiggerText>
              We apologize. There was a problem submitting your data.
            </HeadBiggerText>
          </HeadBiggerTextContainer>
          <BlueLine />
        </HeadWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <HeadWrapper>
        <HeadBiggerTextContainer>
          <HeadBiggerText>
            Thank you for submitting your request.
          </HeadBiggerText>
        </HeadBiggerTextContainer>
        <BlueLine />
      </HeadWrapper>
      <TextsContainer>
        <BiggerTextContainer>
          <BiggerText></BiggerText>
        </BiggerTextContainer>
        {lenderMatchContent}
      </TextsContainer>
      <BottomTextContainer>
        <BottomText>
          Your Request: RateZip receives compensation for connecting consumers with participating mortgage lenders. Not all lenders may be included. Any potential loan terms would be determined solely by the lender after completion of a mortgage application and verification of required information.
        </BottomText>
      </BottomTextContainer>
    </Wrapper>
  );
};

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => $align === "left" ? "flex-start" : "center"};
  gap: 0.5rem;
  margin: 3rem 0;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    color: #666666;
    font-size: 1rem;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 0.75rem;
    }
  }
`;

const LenderLogo = styled.img`
  width: 150px;
`;

const Wrapper = styled(theme.column_align)`
  width: 95%;
  max-width: 900px;
  min-height: 45vh;
  margin-top: 2rem;
`;

const HeadWrapper = styled.div`
  width: 100%;
`;

const HeadBiggerTextContainer = styled.div``;

const HeadBiggerText = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 64px;
  margin-bottom: 16px;
  margin-top: 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const BlueLine = styled.div`
  width: 86px;
  height: 4px;
  background: ${theme.primary_light};
`;

const TextsContainer = styled.div`
  width: 100%;
`;

const BiggerTextContainer = styled.div``;

const BiggerText = styled.h2`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  margin: 32px 0px 0px 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 18px;
    line-height: 32px;
  }
`;

const SmallerTextContainer = styled.div``;

const SmallerText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1.5rem;
  text-align: ${({ $align }) => $align || "center"};
  line-height: 24px;
  color: #000000;
  margin: 0px 0px 16px 0px;
  @media (max-width: ${theme.mobile}) {
    font-size: 14px;
  }
`;

const BottomTextContainer = styled.div``;

const BottomText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #666666;
`;

export default Result;
